import FirmaConformidadClass from "src/app/model/api/datos/firmaConformidadClass";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class FirmasConformidadTable extends DatabaseTable<FirmaConformidadClass> {
    
    public async getAll(): Promise<FirmaConformidadClass[]> {
        return await this.GetAllRecords()
    }

    public async getById(Id: number): Promise<FirmaConformidadClass> {
        let records = await this.GetRecordsByIndex(0, 1, 'Id', Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByLocalId(Id: number): Promise<FirmaConformidadClass> {
        let records = await this.GetRecordsById(0, 1, Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByOrdenLocalId(OrdenLocalId: number): Promise<FirmaConformidadClass> {
        let records = await this.GetRecordsByIndex(0, 1, 'OrdenLocalId', OrdenLocalId, OrdenLocalId)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async update(record: FirmaConformidadClass): Promise<number> {
        return await this.UpdateRecord(record)
    }

    public async delete(record: FirmaConformidadClass): Promise<void> {
        if (!record?.LocalId) return
        await this.DeleteRecord(record.LocalId)
    }

}